import { useTranslation } from "react-i18next";

import { cn } from "@/lib/utils/cn";

/**
 * A free-text "Autre — précisez" value, rendered as a labelled note.
 *
 * These values are typed by a user, so they can run to a full sentence.
 * Rendering one as a chip beside the catalogue options made a long value
 * illegible and passed it off as a validated selection — hence a labelled,
 * wrapping line. The Django counterpart is `templates/includes/_precision.html`.
 */
export function PrecisionNote({
  text,
  className,
}: {
  text?: string | null;
  className?: string;
}) {
  const { t } = useTranslation();
  if (!text?.trim()) return null;
  return (
    <p className={cn("text-sm leading-relaxed text-muted-foreground", className)}>
      <span className="font-semibold text-foreground">
        {t("common.precision")}
      </span>{" "}
      <span className="whitespace-pre-line break-words">{text}</span>
    </p>
  );
}
